import * as React from 'react';

function SvgPhone(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M18.487 22.627c-.225-.001-.448-.026-.667-.074A22.607 22.607 0 016.74 16.72a21.807 21.807 0 01-6-10.833 3.053 3.053 0 01.9-2.854L4.307.467a1.333 1.333 0 011.026-.36 1.333 1.333 0 01.967.58l3.333 4.926A1.067 1.067 0 019.56 6.88l-1.673 2a12.626 12.626 0 002.78 3.927 12.841 12.841 0 004.046 2.726l2.074-1.646a1.093 1.093 0 011.24-.08l5.033 3.253a1.332 1.332 0 01.273 2.073l-2.6 2.574a3.16 3.16 0 01-2.246.92zm-13.26-21.2L2.56 3.993a1.693 1.693 0 00-.5 1.6 20.466 20.466 0 005.607 10.174 21.266 21.266 0 0010.426 5.486 1.833 1.833 0 001.667-.493l2.6-2.573-4.86-3.14-2.227 1.773a.668.668 0 01-.613.113 13.372 13.372 0 01-4.907-3.166 12.994 12.994 0 01-3.246-4.8.667.667 0 01.16-.634l1.8-2.153-3.24-4.753z" />
    </svg>
  );
}

export default SvgPhone;
